import { del, get, jsonParser, post, put } from "./Client";

export const getCategory = (category) => 
  get(`/categories/${category.id}`).then(jsonParser);

export const searchCategories = (query, all = false, page = 0, sort = "order", order = "ASC", drinkId = null) =>
  get(`/categories/alt-list?query=${query}&all=${all ? "true" : "false"}&page=${page}&sort=${sort}&order=${order}${!!drinkId ? "&drinkId=" + drinkId : ""}`)
    .then(jsonParser);

export const createCategory = (category) =>
  post("/categories", { body: category }).then(jsonParser);

export const updateCategory = (category) =>
  put(`/categories/${category.id}`, { body: category }).then(jsonParser);

export const deleteCategory = (category) => 
  del(`/categories/${category.id}`).then(jsonParser);

export const getAllCategories = (sort = "nameBr", order = "ASC") => 
  get(`/categories/all?sort=${sort}&order=${order}`).then(jsonParser);

export const listCategoriesByDrinkId = (drinkId, sort = "order", order = "ASC") =>
  get(`/categories/all/drink/${drinkId}?sort=${sort}&order=${order}`).then(jsonParser);

export const importCategoryExcelData = (data) =>
  post("/categories/import/excel", { body: data }).then(jsonParser);